import {
  BaseIntegration,
  HUBSPOTv2,
  useServices,
} from 'organization/Event/Services/ServicesProvider'
import React from 'react'
import {useQueryParams} from 'lib/url'
import AuthPage from 'organization/Event/Services/Apps/HubspotV2/AuthPage'
import Config from 'organization/Event/Services/Apps/HubspotV2/Config'
import LinkPage from 'organization/Event/Services/Apps/HubspotV2/LinkPage'
import {Property} from 'organization/Event/Services/Apps/HubspotV2/Config/HubspotV2PropertiesProvider'

export type HubspotV2Integration = BaseIntegration & {
  service: typeof HUBSPOTv2
  has_completed_setup: boolean

  imported_at: string | null
  has_set_import_tag: boolean

  login_property_name: string
  login_property_label: string
  login_property_type: Property['type'] | null

  tags_property_name: string
  tags_property_label: string
  tags_property_type: Property['type'] | null

  phone_property_name: string
  phone_property_label: string
  phone_property_type: Property['type'] | null

  portal_id: string
  tags: HubspotV2PlatformTag[]
  groups: HubspotV2Group[]
}

export interface HubspotV2Group {
  property_name: string
  property_label: string
  property_type: Property['type']
  key: string | null
}

export interface HubspotV2PlatformTag {
  id: number
  property_label: string | null
  property_name: string | null
  property_type: Property['type'] | null
  property_value: string | null
  type: TagType
}

/**
 * Tag types as defined in API's HubspotV2TagType class
 */
export const IMPORT_TAG = 'import_tag'
export const ATTENDEE_CREATED = 'attendee_created'
export const ATTENDEE_SIGNED_WAIVER = 'attendee_signed_waiver'
export const ATTENDEE_CHECKED_IN = 'attendee_checked_in'
export const FORM_SUBMITTED = 'form_submitted'

export type TagType =
  | typeof IMPORT_TAG
  | typeof ATTENDEE_CREATED
  | typeof ATTENDEE_CHECKED_IN
  | typeof ATTENDEE_SIGNED_WAIVER
  | typeof FORM_SUBMITTED

export default function HubspotV2() {
  const {isLinked} = useServices()
  const showConfig = isLinked(HUBSPOTv2)

  /**
   * HubSpot redirects back with an auth code
   * in a URL param named 'code'
   */
  const {code} = useQueryParams()

  if (showConfig) {
    return <Config />
  }

  if (code) {
    return <AuthPage authCode={code} />
  }

  return <LinkPage />
}
